export function singularOrPlural(count, singular, plural) {
  if (count === 1) return singular
  else return plural
}
